import React, { useState } from 'react';
import { Icons } from '../../Components';
import moment from 'moment-mini';
import { ItemOrderHelpers } from '../api';
import type { ItemOrderProps } from '../../types';
import ItemOrderDetails from './ItemOrderDetailCard';
import { useColors } from '../../constants/useColors';
import { Button, View, Text } from '../../Components/Themed';

type ItemOrderCardProps = {
    item_order:ItemOrderProps
}
const ItemOrderCard = ({ item_order }:ItemOrderCardProps) => {
    const Colors = useColors();
    const [ expanded, setExpanded ] = useState(false);

    const status_label = ItemOrderHelpers.getStatusLabel(item_order);

    return (
        <View float style={{ borderRadius:0 }}>
            <Button style={{ flex:1, flexDirection:'row', alignItems:'center', padding:10, borderRadius:0, borderBottomWidth:1, borderBottomColor:Colors.borders.light }} onPress={() => setExpanded(!expanded)}>
                <View nativeID='item_order_info' style={{ flex:3, borderRightWidth:1, borderColor:Colors.borders.light }}>
                    <Text theme='h2'>{item_order.description}</Text>
                    <Text style={{ marginTop:4 }} theme='light'>Created at {moment(item_order.create_datetime).format('YYYY-MM-DD hh:mm a')}</Text>
                </View>
                <View nativeID='item_order_amount' style={{ flex:1, padding:5 }}>
                    <Text size={14} theme='h1' textAlign='center'>${item_order.total_amount.toFixed(2)}</Text>
                    <View style={{ marginTop:3, padding:3, paddingRight:10, paddingLeft:10, backgroundColor:status_label.color, borderRadius:8}}>
                        <Text theme='description' color={Colors.text.white} textAlign='center'>{status_label.text}</Text>
                    </View>
                </View>
                <View style={{ padding:10 }}>
                    <Icons.ChevronIcon direction={expanded?'up':'down'} size={8} color={Colors.text.h1}/>
                </View>
            </Button>
            {expanded ?
            <View style={{ padding:20 }}>
                <ItemOrderDetails
                    item_order={item_order}
                />
            </View>
            :<></>}
        </View>
    )
}

export default ItemOrderCard